export const DAYS_OF_WEEK = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

export function getOfficeHours(providerInformation = {}) {
  return providerInformation?.office_hours ?? providerInformation?.officeHours ?? [];
}

export function buildDayRows(providerInformation = {}) {
  const officeHours = getOfficeHours(providerInformation);
  return DAYS_OF_WEEK.map((label, index) => ({
    day: label,
    dayIndex: index,
    timings: officeHours
      .filter((item) => Number(item?.day) === index)
      .map((item) => ({
        id: item?.id,
        startTime: item?.start_time ?? item?.startTime ?? "",
        endTime: item?.end_time ?? item?.endTime ?? "",
      }))
      .sort((left, right) => left.startTime.localeCompare(right.startTime)),
  }));
}
